import { useQuery } from '@tanstack/react-query';
import { organizationRepository } from '../repositories/organization.repository';
import { orgKeys } from '../services/organization.keys';
import type { Organization } from '../types/organization.types';

export function useCurrentOrganization() {
  return useQuery({
    queryKey: orgKeys.current(),
    queryFn: async (): Promise<Organization | null> => {
      const orgId = await organizationRepository.getCurrentUserOrganizationId();
      if (!orgId) return null;
      return organizationRepository.getOrganizationById(orgId);
    },
    enabled: true,
  });
}
